import React from "react"
import { Box, Container, Flex, Grid, Text } from "theme-ui"
import SectionTitle from "./sectionTitle"
import Img from "gatsby-image"
import { Link } from "theme-ui"

const Team = ({ title, people }) => (
  <Box sx={{ mt: 5 }}>
    <Container>
      <SectionTitle title={title} />
      <Grid columns={[2, 2, 3]} gap={3}>
        {people.map(person => (
          <Box sx={{ mb: 4, position: "relative" }} key={person.id}>
            <Img fluid={person.image.fluid} />
            <Flex sx={{ flexDirection: "column", mt: 2 }}>
              <Text variant="headingSmall">{person.name}</Text>
              <Text sx={{ fontSize: [0, 1] }}>{person.jobFunction}</Text>
              <Link
                sx={{ fontSize: [0, 1], overflowWrap: "break-word" }}
                href={`mailto:${person.email}`}
              >
                {person.email}
              </Link>
            </Flex>
          </Box>
        ))}
      </Grid>
    </Container>
  </Box>
)

export default Team
